import { Theme, useMediaQuery } from '@material-ui/core'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'

export const useBreakpoint = (breakpoint: Breakpoint, down?: boolean) =>
  useMediaQuery(
    (theme: Theme) =>
      down ? theme.breakpoints.down(breakpoint) : theme.breakpoints.up(breakpoint),
    { defaultMatches: true }
  )
export const useFullScreenModalBreakpoint = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
